import React from 'react'
import { cn } from '../../../../../../utils/classnames'
import { formatCurrency } from '../../../../../../utils/formatters'

const MovementRow = ({ movement, index }) => {
  const isEven = index % 2 === 0
  const bgClass = isEven ? 'bg-white' : 'bg-transparent'

  return (
    <tr className={cn('text-blueDarker', bgClass)}>
      <td className="m-1 rounded-l-xl py-3 px-2 py-4 text-lg font-semibold truncate" title={movement.asset}>
        {movement.asset}
      </td>
      <td className="text-lg px-2 truncate" title={movement.launchType}>{movement.launchType}</td>
      <td className="text-lg px-2">{movement.accountNumber}</td>
      <td className="text-lg px-2">{movement.formattedDate}</td>
      <td className="text-lg px-2">{formatCurrency(movement.grossValue)}</td>
      <td className="pr-4 rounded-r-xl text-lg px-2 truncate" title={movement.movementHistory}>{movement.movementHistory}</td>
    </tr>
  )
}

export default MovementRow
